import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const Background = styled.div`
  background-color: ${colors.white};
`

export const Container = styled.div`
  height: 88px;
  background: ${colors.white};
  display: flex;
  box-shadow: rgb(0 0 0 / 25%) 0px 0px 6px;
  border-radius: 4px;
  padding: 4px;
`

export const CoverWrapper = styled.div`
  position: relative;
  height: 100%;
  max-height: 100%;
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;

  > img {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 80px;
  }
`

export const Button = styled.button`
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
  border: 1px ${colors.white} solid;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: rgb(0 0 0 / 40%) 0px 0px 10px;
  transition: transform 0.1s ease 0s;

  :hover {
    transform: scale(1.1);
  }

  > img {
    width: 26px;
    height: 26px;
  }
`

export const Content = styled.div`
  color: ${colors.white};
  font-size: 14px;
  line-height: 21px;
  background: linear-gradient(180deg, #5d8d8f 0%, #1b302d 100%);
  display: grid;
  grid-template-columns: 1fr 32px;
  grid-template-rows: repeat(3, auto);
  width: 100%;
  padding: 7px 9.26px 7px 24px;
  grid-template-areas:
    'track tiktok'
    'artist duration'
    'line link';

  @media ${device.mobileMin} {
    padding: 7px 9.26px 7px 8px;
  }
`

export const TrackInfo = styled.div`
  display: grid;
  text-align: left;
  margin-left: 0.5rem;
`

export const TrackName = styled.div`
  font-weight: bold;
  grid-area: track;
  text-align: left;
  padding-left: 14px;
`

export const ArtistName = styled.div`
  font-weight: bold;
  grid-area: artist;
  text-align: left;
  padding-left: 14px;
`

export const Signs = styled.div`
  display: grid;
`

const sliderSize = 0.7
export const Slider = styled.div`
  position: absolute;
  right: -${sliderSize / 2}rem;
  top: -${sliderSize / 3}rem;
  height: ${sliderSize}rem;
  width: ${sliderSize}rem;
  background-color: ${colors.white};
  border-radius: 50%;
  opacity: 0;
`

export const TrackWrapper = styled.div`
  position: relative;
  flex-grow: 1;
  height: 4px;
  cursor: pointer;
  grid-area: line;

  :hover ${Slider} {
    opacity: 1;
  }
`

export const Track = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: ${colors.white};
`

export const TikTokWhiteIconWrapper = styled.div`
  grid-area: tiktok;
`

export const Duration = styled.div`
  font-size: 0.625rem;
  margin-left: 0.5rem;
  grid-area: duration;
`

export const CurlLinkIconWrapper = styled.div`
  grid-area: link;
`
